import { useAppStore } from '../../state/store';
import { ProjectUnitsDialog } from './ProjectUnitsDialog';
import { SnapsDialog } from './SnapsDialog';
import { MaterialsDialog } from './materials/MaterialsBrowserDialog';
import { ObjectStylesDialog } from './ObjectStylesDialog';
import { LocationDialog } from './LocationDialog';
import { PhasingDialog } from './PhasingDialog';
import { DesignOptionsDialog } from './DesignOptionsDialog';
import { IDSelectionDialog } from './IDSelectionDialog';
import { StartingViewDialog } from './StartingViewDialog';
import { MacroManagerDialog } from './MacroManagerDialog';
import { ManageImagesDialog } from './ManageImagesDialog';
import { ManageLinksDialog } from '../insert/ManageLinksDialog';
import { CloudFamilyDialog } from '../insert/CloudFamilyDialog';
import { TypePropertiesDialog } from '../typeProperties';
import { VisibilityGraphicsDialog } from './VisibilityGraphicsDialog';
import { ScheduleDialog } from '../ui/ScheduleDialog';
import { CommandPresetsDialog } from './CommandPresetsDialog';
import { AppLoadDialog } from './AppLoadDialog';
import { DimensionStylesDialog } from './DimensionStylesDialog';
import { LoadCasesDialog } from '../analyze/LoadCasesDialog';
import { EnergySettingsDialog } from '../analyze/EnergySettingsDialog';
import { AnalysisResultsDialog } from '../analyze/AnalysisResultsDialog';
import { PrecastConfigurationDialog } from '../precast/PrecastConfigurationDialog';
import { PrecastShopDrawingsDialog } from '../precast/PrecastShopDrawingsDialog';
import { PrecastCamExportDialog } from '../precast/PrecastCamExportDialog';

/**
 * Central mount point for all Manage tab dialogs. Rendered once in the
 * global layout; visibility is driven by appStore.manageDialog.
 */
export function ManageDialogsHost() {
    const manageDialog = useAppStore((state) => state.manageDialog);

    if (!manageDialog) return null;

    switch (manageDialog) {
        case 'units':
            return <ProjectUnitsDialog />;
        case 'snaps':
            return <SnapsDialog />;
        case 'materials':
            return <MaterialsDialog />;
        case 'objectStyles':
            return <ObjectStylesDialog />;
        case 'location':
            return <LocationDialog />;
        case 'phasing':
            return <PhasingDialog />;
        case 'designOptions':
            return <DesignOptionsDialog />;
        case 'idSelection':
            return <IDSelectionDialog />;
        case 'startingView':
            return <StartingViewDialog />;
        case 'macros':
            return <MacroManagerDialog />;
        case 'images':
            return <ManageImagesDialog />;
        case 'manageLinks':
            return <ManageLinksDialog />;
        case 'cloudFamily':
            return <CloudFamilyDialog />;
        case 'typeProperties':
            return <TypePropertiesDialog />;
        case 'visibilityGraphics':
            return <VisibilityGraphicsDialog />;
        case 'schedules':
            return <ScheduleDialog />;
        case 'analyzeLoadCases':
            return <LoadCasesDialog />;
        case 'analyzeEnergySettings':
            return <EnergySettingsDialog />;
        case 'analyzeResults':
            return <AnalysisResultsDialog />;
        case 'precastConfig':
            return <PrecastConfigurationDialog />;
        case 'precastShopDrawings':
            return <PrecastShopDrawingsDialog />;
        case 'precastCamExport':
            return <PrecastCamExportDialog />;
        case 'commandPresets':
            return <CommandPresetsDialog />;
        case 'dimStyles':
            return <DimensionStylesDialog />;
        case 'appLoad':
            return <AppLoadDialog />;
        default:
            return null;
    }
}
